import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from '../types';
import config from '../config/env';
import logger from './logger';

// Create axios instance
const api = axios.create({
  baseURL: config.api.baseUrl,
  timeout: config.api.timeout,
  withCredentials: true,
});

// Debug: Log the base URL (development only - handled by logger)
logger.log('API Base URL:', config.api.baseUrl);

// SECURITY UPDATE: Tokens now stored in httpOnly cookies + CSRF protection
// Request interceptor updated to work with cookies and CSRF
api.interceptors.request.use(
  (config) => {
    // DEVELOPMENT ONLY: Support localStorage fallback for testing
    if (process.env.NODE_ENV === 'development') {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // CSRF Protection: Add CSRF token for state-changing requests
    if (config.method && ['POST', 'PUT', 'DELETE', 'PATCH'].includes(config.method.toUpperCase())) {
      const csrfToken = localStorage.getItem('csrfToken');
      if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    }

    // In production, tokens are automatically sent via httpOnly cookies
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response: AxiosResponse<ApiResponse<any>>) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // SECURITY UPDATE: Clear both localStorage and httpOnly cookies handled on server
      if (process.env.NODE_ENV === 'development') {
        localStorage.removeItem('token'); // Development fallback
      }
      // Don't redirect automatically - let components handle authentication state
      logger.log('Authentication failed - user needs to login');
    }
    return Promise.reject(error);
  }
);

export default api;
